/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Component, ViewEncapsulation, ContentChildren, QueryList, Input} from '@angular/core';
import {mixinDisabled, CanDisable} from '../common-behaviors/disabled';
export class MdOptgroupBase { }
export const /** @type {?} */ _MdOptgroupMixinBase = mixinDisabled(MdOptgroupBase);

// Counter for unique group ids.
let /** @type {?} */ _uniqueOptgroupIdCounter = 0;
/**
 * Component that is used to group instances of `md-option`.
 */
export class MdOptgroup extends _MdOptgroupMixinBase implements CanDisable {
/**
 * Label for the option group.
 */
label: string;
/**
 * Unique id for the underlying label.
 */
_labelId: string = `mat-optgroup-label-${_uniqueOptgroupIdCounter++}`;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-optgroup, mat-optgroup',
  templateUrl: 'optgroup.html',
  encapsulation: ViewEncapsulation.None,
  inputs: ['disabled'],
  host: {
    'class': 'mat-optgroup',
    'role': 'group',
    '[class.mat-optgroup-disabled]': 'disabled',
    '[attr.aria-disabled]': 'disabled.toString()',
    '[attr.aria-labelledby]': '_labelId',
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
};
}

function MdOptgroup_tsickle_Closure_declarations() {
/** @type {?} */
MdOptgroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdOptgroup.ctorParameters;
/** @type {?} */
MdOptgroup.propDecorators;
/**
 * Label for the option group.
 * @type {?}
 */
MdOptgroup.prototype.label;
/**
 * Unique id for the underlying label.
 * @type {?}
 */
MdOptgroup.prototype._labelId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
